import "../../scss/components/videoPopup.scss";

document.addEventListener("DOMContentLoaded", function () {
  let isPopupShowing = false;
  let intervalId = null;
  let buttonIntervalId = null;
  let timer = null;
  let isCloseEnabled = false;
  const videoPlayer = document.querySelector(".video-wrapper-scrollable");
  const popupData = document.getElementById("archived-video__popup");

  if (!popupData) {
    return;
  }
  const frequency = popupData.getAttribute("data-frequency");
  const closeAt = popupData.getAttribute("data-close-time");
  const occurrenceTime = popupData.getAttribute("data-occurrence-time");
  const startingTime = popupData.getAttribute("data-starting-time");
  const popupContainer = document.querySelector(
    ".archived-video__popup-container"
  );
  const popupCloseBtn = document.querySelector(".archived-video__popup-close");
  const video = videoPlayer.querySelector("video");

  if (startingTime !== "session") {
    return;
  }

  function timeToSeconds(timeString) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  function calculateAsSeconds(duration) {
    return Math.floor(duration * 1000);
  }

  const showPopup = () => {
    clearTimeout(timer);
    clearInterval(intervalId);

    popupData.style.display = "block";

    clearTimeout(timer);
    timer = setTimeout(() => {
      popupContainer.classList.add("show");
    }, 300);

    isPopupShowing = true;

    if (popupCloseBtn) {
      popupCloseBtn.classList.remove("button-show");
    }

    isCloseEnabled = false;

    clearTimeout(buttonIntervalId);
    buttonIntervalId = setTimeout(() => {
      setupPopupCloseHandler();
    }, calculateAsSeconds(closeAt));
  };

  const hidePopup = () => {
    video && video.play();
    clearTimeout(buttonIntervalId);
    clearTimeout(timer);

    if (popupData) {
      popupData.style.display = "none";
      popupContainer.classList.remove("show");
      isPopupShowing = false;

      if (popupCloseBtn) {
        popupCloseBtn.classList.remove("button-show");
      }

      if (frequency === "repeat") {
        clearInterval(intervalId);
        intervalId = setInterval(() => {
          triggerAd();
        }, timeToSeconds(occurrenceTime) * 1000);
      }
    }

    isCloseEnabled = false;
  };

  const setupPopupCloseHandler = () => {
    if (popupCloseBtn) {
      popupCloseBtn.classList.add("button-show");

      isCloseEnabled = true;

      popupCloseBtn.removeEventListener("click", hidePopup);
      popupCloseBtn.addEventListener("click", hidePopup);
    }

    if (popupData) {
      popupData.removeEventListener("click", handlePopupSectionClick);
      popupData.addEventListener("click", handlePopupSectionClick);
    }
  };

  const handlePopupSectionClick = (event) => {
    if (event.target === popupData && isCloseEnabled) {
      hidePopup();
    }
  };

  let isVideoPlaying = false;

  if (video) {
    video.addEventListener("playing", () => {
      isVideoPlaying = true;
    });
    video.addEventListener("pause", () => {
      isVideoPlaying = false;
    });
  }

  const triggerAd = () => {
    if (
      (document.fullscreenElement || document.webkitFullscreenElement) &&
      document.exitFullscreen
    ) {
      video.pause();
      document.exitFullscreen();
    } else if (navigator.userAgent.match(/iPhone/i)) {
      videoPlayer.getElementsByTagName("video")[0].webkitExitFullScreen();
    } else if (isVideoPlaying) {
      video.pause();
    }
    showPopup();
  };

  if (frequency === "once") {
    setTimeout(() => {
      triggerAd();
    }, timeToSeconds(occurrenceTime) * 1000);
  } else if (frequency === "repeat") {
    intervalId = setInterval(() => {
      triggerAd();
    }, timeToSeconds(occurrenceTime) * 1000);
  }
});
